"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.graphqlEntityTypeName = exports.graphqlFormatFieldName = exports.graphqlFormatTypeName = void 0;
var camelcase_1 = __importDefault(require("camelcase"));
var snake_case_1 = require("snake-case");
var pascalCase = function (text) {
    var cameled = camelcase_1.default(text);
    return cameled.substr(0, 1).toUpperCase() + cameled.substr(1);
};
exports.graphqlFormatTypeName = function (text) { return pascalCase(text); };
exports.graphqlFormatFieldName = function (text) { return snake_case_1.snakeCase(text); };
exports.graphqlEntityTypeName = function (entity) { return exports.graphqlFormatTypeName(entity.getSingular()); };
